import { Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';

import { routeName } from './route-name';

export const routeKeyData = {
    dauGuid: 'dauGuid',
    pamGuid: 'pamGuid',
    iKey: 'iKey',
    key: 'key'
} as const;

export type TRouteKeyData = typeof routeKeyData[keyof typeof routeKeyData];

export interface IRouteKeyData
{
    [routeKeyData.dauGuid]?: string | null;
    [routeKeyData.pamGuid]?: string | null;
    [routeKeyData.iKey]?: string | null;
    [routeKeyData.key]?: string | null;
}

Injectable({
    providedIn: 'root'
})
export class RouteKeyData
    implements IRouteKeyData
{
    [routeKeyData.dauGuid]?: string | null;
    [routeKeyData.pamGuid]?: string | null;
    [routeKeyData.iKey]?: string | null;
    [routeKeyData.key]?: string | null;

    constructor(routePath: string, router: Router);
    constructor(routeKeyData: IRouteKeyData);
    constructor(value1: string | IRouteKeyData, router?: Router) {
        let __routeParams: IRouteKeyData;

       if (typeof(value1) === 'string') {
            const __routePath = value1;
            const __router = router as Router;
            __routeParams = this._routeParams_fromPath(__routePath, __router);
        } else {
            __routeParams = value1;
        }

        this[routeKeyData.key] = __routeParams[routeKeyData.key];
        this[routeKeyData.iKey] = __routeParams[routeKeyData.iKey] ?? __routeParams[routeKeyData.key] as string;
        this[routeKeyData.dauGuid] = __routeParams[routeKeyData.dauGuid] ?? null;
        this[routeKeyData.pamGuid] = __routeParams[routeKeyData.pamGuid] ?? null;
    }

    private _routeParams_fromPath(routePath: string, router: Router): IRouteKeyData {
        if (!routePath) throw new Error('Invalid route path');

        const segments = router.parseUrl(routePath).root.children['primary'].segments.map(s => s.path);
        const dauVal = this._segmentAfter(segments, routeName.domains);
        const pamVal = this._segmentAfter(segments, routeName.projects);
        const key = segments.at(-1) ?? null;

        return {
            dauGuid: this._parseGuid(dauVal),
            pamGuid: this._parseGuid(pamVal),
            iKey: null,
            key
        };
    }

    private _segmentAfter(segments: string[], name: string): string | null {
        const idx = segments.indexOf(name);
        return idx >= 0 && idx + 1 < segments.length ? segments[idx + 1] : null;
    }

    private _parseGuid(val: string | null): string | null {
        return val && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val) ? val : null;
    }
}
